"use client";
import React, { useState } from "react";
import styling from "./loginContainer.module.css";
import Login from "../../components/Login";
interface Props {
  // define any props needed for the component
}

const LoginContainer: React.FC<Props> = () => {
  return (
    <div className={styling.loginBg}>
      <Login />
    </div>
  );
};

export default LoginContainer;
